import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Users")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Organizations")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("My Organization")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Crash Files")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Workflows")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Global Config")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Settings")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Logout")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_menu = _resolveComponent("el-menu")

  return (_openBlock(), _createBlock(_component_el_menu, {
    class: "navbar",
    mode: "horizontal",
    router: true,
    "background-color": "#2F2F2F",
    "text-color": "#fff",
    "active-text-color": "#ffd04b"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, {
        index: "1",
        route: { name: 'UsersPage' }
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      (_ctx.isVAR || _ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 0,
            index: "2",
            route: { name: 'OrganizationsPage', params: {} }
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 1,
            index: "2",
            route: {
        name: 'OrganizationsFormEdit',
        params: { id: _ctx.account?.organizations_id },
      }
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["route"])),
      _createVNode(_component_el_menu_item, {
        index: "4",
        route: { name: 'CrashFilesPage' }
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }),
      (_ctx.isVAR || _ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 2,
            index: "5",
            route: { name: 'WorkflowsPage' }
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock(_component_el_menu_item, {
            key: 3,
            index: "7",
            route: { name: 'GlobalConfigPage' }
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_el_submenu, {
        class: "account-menu",
        index: "6"
      }, {
        title: _withCtx(() => [
          _createTextVNode("Welcome, " + _toDisplayString(_ctx.account?.first_name), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_menu_item, {
            index: "6-1",
            route: {
          name: 'ProfilePage',
        }
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_el_menu_item, {
            index: "/",
            onClick: _ctx.logout
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}